<template>
  <main id="main">
    <div style="height: 45vh" class="bg_light_theme w-100 rounded_div position-relative">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <img src="@/assets/imgs/ayendaman-pic-2.png" class="logo" alt="">
      </div>
    </div>

    <div class="p-3">
      <div class="mb-5">
        <p class="bold font_large text_black mb-3">{{ t('login_email_title') }}</p>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="rounded-pill p-3 bg_white shadow_input">
            <img src="@/assets/imgs/email-_3_.svg" class="icon-size-5" alt="">
          </div>
          <input class="rounded-pill p-4 w-85" type="email" :placeholder="t('email_placeholder')" v-model="email">
        </div>
        <p class="font_small mt-3 text-center">
          {{ t('login_terms') }}
          <span class="text_color_blue cursor-pointer" @click="openInfo('rules')">{{ t('terms_conditions') }}</span> 
          و 
          <span class="text_color_blue cursor-pointer" @click="openInfo('privacy')">{{ t('privacy') }}</span> 
          میباشد.
        </p>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <button class="button" @click="sendOtp" :disabled="loading">
          {{ loading ? t('send_otp') : t('submit_continue') }}
        </button>
      </div>
    </div>
    
    <div class="w-100 max_width d-flex justify-content-end position-fixed bottom-3 p-3">
      <img src="@/assets/imgs/whatsapp.svg" class="icon-size-8 cursor-pointer" alt="" @click="openWhatsApp">
    </div>

    <div v-if="showInfoModal" class="modal_overlay" @click.self="closeInfoModal">
      <div class="modal_content_info bg_white rounded-4 p-4 shadow_box">
        <div v-if="infoModalLoading" class="text-center">
          <p>{{ t('loading') }}</p>
        </div>
        <div v-else class="content-wrapper">
          <div v-html="infoModalContent" class="html-content"></div>
        </div>
        <div class="d-flex justify-content-center mt-4">
          <button class="button w-50 py-2 font_small" @click="closeInfoModal">{{ t('cancel') }}</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      loading: false,
      showInfoModal: false,
      infoModalContent: '',
      infoModalLoading: false
    }
  },
  methods: {
    async sendOtp() {
      if (!this.email) return this.notify(this.t('login_email_title'), 'error')
      
      this.loading = true
      
      try {
        const formData = createFormData({ email: this.email })
        const response = await apiClient.post('/login_email', formData)
        
        if (response.data.status === 'ok' || response.data === true || response.data.data) {
          localStorage.setItem('user_email', this.email)
          
          if (response.data.data) {
            this.notify(`Debug OTP: ${response.data.data}`, 'info', 10000)
          }
          
          this.$router.push({ name: 'Otp' })
        } else {
          const errMsg = response.data.message ? response.data.message : this.t('error_submit')
          this.notify(errMsg, 'error')
        }

      } catch (error) {
        let message = ''
        if (error.response && error.response.data && error.response.data.message) {
          message = error.response.data.message
        } else {
          message = error.message || this.t('connection_error')
        }
        this.notify(message, 'error')
      } finally {
        this.loading = false
      }
    },
    async openInfo(action) {
      this.showInfoModal = true;
      this.infoModalLoading = true;
      this.infoModalContent = '';

      try {
        const formData = createFormData({ action: action });
        const response = await apiClient.post('/public_info', formData);

        if (typeof response.data === 'string') {
          this.infoModalContent = response.data;
        } else if (response.data.status === true || response.data.status === 'ok') {
          const rawData = response.data.data;
          const processedData = (typeof rawData === 'string' && !rawData.startsWith('<')) 
                                ? Decryption(rawData) 
                                : rawData;
          
          if (processedData) {
             this.infoModalContent = (typeof processedData === 'object' && processedData.value) 
                            ? processedData.value 
                            : processedData;
          }
        }
      } catch (error) {
        this.notify(error.message, 'error');
        this.infoModalContent = 'Error fetching info';
      } finally {
        this.infoModalLoading = false;
      }
    },
    closeInfoModal() {
      this.showInfoModal = false;
    },
    async openWhatsApp() {
      try {
        const formData = createFormData({ action: 'whatsapp' })
        const response = await apiClient.post('/public_info', formData)
        
        let url = ''
        if (typeof response.data === 'string') {
           url = response.data
        } else if (response.data.data) {
           url = response.data.data
        }
        
        if (url) {
           url = url.replace(/"/g, '')
           window.open(url, '_blank')
        }
      } catch (error) {
        this.notify(error.message, 'error');
      }
    }
  }
}
</script>

<style scoped>
.rounded_div {
  border-bottom-left-radius: 5rem;
  border-bottom-right-radius: 5rem;
}
.logo {
  width: 25rem;
}
.text_black {
  color: #000;
}
.text_color_blue {
  color: #4A00E0; 
}
.cursor-pointer {
  cursor: pointer;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content_info {
  width: 90%;
  max-width: 30rem;
  max-height: 80vh;
  overflow-y: auto;
  animation: fadeIn 0.3s ease-out;
}
:deep(.html-content),
:deep(.html-content *) {
  color: #333 !important;
  font-family: inherit !important;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>